var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlertTriangle = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none",
  stroke: "#DB5C67",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.96,
  clipPath: "url(#alert-triangle_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.145 1.93.91 9a1 1 0 0 0 .855 1.5h8.47A1 1 0 0 0 11.09 9L6.855 1.93a1 1 0 0 0-1.71 0v0ZM6 4.5v2M6 8.5h.005"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "alert-triangle_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
})))));
SvgAlertTriangle.viewBox = null;
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlertTriangle);
export default ForwardRef;